const school_train_routes = [
    [
        {
            path: "/userData",
            name: "userData",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: 'xxx测评'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolTrainTest" */
                    "../../views/schoolTrain/userData/index.vue"
                ),
        },
        // 校培训教师微能力测评
        {
            path: "/schooltraintest",
            name: "SchoolTrainTest",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: 'xxx测评'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolTrainTest" */
                    "../../views/schoolTrain/SchoolTrainTest.vue"
                ),
        },
        // 校培训教师微能力申报
        {
            path: "/schooltraindeclare",
            name: "SchoolTrainDeclare",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: '教师微能力申报'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolTrainDeclare" */
                    "../../views/schoolTrain/SchoolTrainDeclare.vue"
                ),
        },
        // 校培训待评审
        {
            path: "/schooltrainwaitjudge",
            name: "SchoolTrainWaitJudge",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '成果评审'
                },
                {
                    path: '/',
                    name: '待评审'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolTrainWaitJudge" */
                    "../../views/schoolTrain/SchoolTrainWaitJudge.vue"
                ),
        },
        // 校培训已评审
        {
            path: "/schooltrainhadjudge",
            name: "SchoolTrainHadJudge",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '成果评审'
                },
                {
                    path: '/',
                    name: '已评审'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolTrainWaitJudge" */
                    "../../views/schoolTrain/SchoolTrainWaitJudge.vue"
                ),
        },
        // 校培训教师认定
        {
            path: "/schooltraintearcherrd",
            name: "SchoolTrainTearcherRd",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '教师信息技术应用能力认定'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolTrainTearcherRd" */
                    "../../views/schoolTrain/SchoolTrainTearcherRd.vue"
                ),
        },
        // 校培训教师认定详情
        {
            path: "/schooltraintearcherrddetail",
            name: "SchoolTrainTearcherRd",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '教师信息技术应用能力认定'
                },
                {
                    path: '/',
                    name: '查看详情'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolTrainTearcherRdDetail" */
                    "../../views/schoolTrain/SchoolTrainTearcherRdDetail.vue"
                ),
        },
        // 信息技术应用课例
        {
            path: "/schoolTrainCourse",
            name: "SchoolTrainCourse",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '信息技术应用课例'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolTrainTearcherRd" */
                    "../../views/schoolTrain/SchoolTrainCourse.vue"
                ),
        },

        // 信息技术应用课例
        {
            path: "/schoolTrainScience",
            name: "SchoolTrainScience",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '信息技术应用课例'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolTrainTearcherRd" */
                    "../../views/schoolTrain/SchoolTrainScience.vue"
                ),
        },
        // 上传信息技术应用课例
        {
            path: "/schoolTrainCourseDetail",
            name: "SchoolTrainCourseDetail",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '信息技术应用课例'
                },
                {
                    path: '/',
                    name: '上传课例'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolTrainTearcherRd" */
                    "../../views/schoolTrain/SchoolTrainCourseDetail.vue"
                ),
        },

        // 详情
        {
            path: "/schoolTrainDetails",
            name: "SchoolTrainDetails",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '信息技术应用课例'
                },
                {
                    path: '/',
                    name: '上传课例'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolTrainTearcherRd" */
                    "../../views/schoolTrain/SchoolTrainDetails.vue"
                ),
        },
        // 校管学校信息化发展计划
        {
            path: "/schoolmngdevelopplan",
            name: "SchoolMngDevelopPlan",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: '学校信息化发展计划'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngDevelopPlan" */
                    "../../views/personal/schoolMng/SchoolMngDevelopPlan.vue"
                ),
        },
        // 校管校本研修与考核方案
        {
            path: "/schoolmngstudyplan",
            name: "SchoolMngStudyPlan",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: '校本研修与考核方案'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngStudyPlan" */
                    "../../views/personal/schoolMng/SchoolMngDevelopPlan.vue"
                ),
        },
        // 微能力测评服务列表
        {
            path: "/abilityevaluation",
            name: "AbilityEvaluation",
            meta: {
                showName: 1,
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: '微能力测评服务'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "AbilityEvaluation" */
                    "../../views/personal/schoolMng/SchoolMngTearcherTest.vue"
                ),
        },
        // 微能力测评服务详情
        {
            path: "/schoolMngTearcherDetails",
            name: "SchoolMngTearcherDetails",
            meta: {
                showName: 1,
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: '微能力测评服务'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "AbilityEvaluation" */
                    "../../views/personal/schoolMng/SchoolMngTearcherDetails.vue"
                ),
        },
        // 个人测评报告测评报告
        {
            path: "/personagetestnoticeschool",
            name: "SchoolMngTearcherDclare",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: '教师微能力测评'
                },
                {
                    path: '/',
                    name: 'xxx测评'
                },
                {
                    path: '/',
                    name: 'xxx教师微能力测评报告'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "PersonageTestNotice" */
                    "../../views/personal/PersonageTestNotice.vue"
                ),
        },
        // 综合测评报告
        {
            path: "/synthesizetestnotice",
            name: "SchoolMngTearcherDclare",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: '教师微能力测评'
                },
                {
                    path: '/',
                    name: 'xxx测评'
                },
                {
                    path: '/',
                    name: '教师微能力测评报告(综合)'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SynthesizeTestNotice" */
                    "../../views/personal/SynthesizeTestNotice.vue"
                ),
        },
    ],
    [
        // 校培训待评审详情
        {
            path: "/nocommentdetail",
            name: "NoCommentDetail",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '成果评审'
                },
                {
                    path: '/',
                    name: '成果详情'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "NoCommentDetail" */
                    "../../views/personal/tearch/ability/NoCommentDetail.vue"
                ),
        },
        // 微能力教师成果认定详情  
        {
            path: '/abilityconfirmdetail',
            name: 'AbilityConfirmDetail',
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '信息技术应用能力认定'
                },
                {
                    path: '/',
                    name: '成果认定'
                },
                {
                    path: '/',
                    name: '成果详情'
                },
                ]
            },
            component: () => import( /* webpackChunkName: "AbilityConfirmDetail" */ '../../views/personal/tearch/ability/AbilityConfirmDetail.vue'),
        },
        // 非微能力教师成果详情
        {
            path: "/noabilityachievementxq",
            name: "NoAbilityAchievementRd",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '信息技术应用能力认定'
                },
                {
                    path: '/',
                    name: '成果认定'
                },
                {
                    path: '/',
                    name: '成果详情'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "NoAbilityAchievementRd" */
                    "../../views/personal/tearch/no_ability/NoAbilityAchievementXq.vue"
                ),
        },
    ]

];

export default school_train_routes;